<button (click)="handleClick()">
  <div class="icon">
    <img [src]="'assets/static/icons/' + iconName + '.svg'" alt="" />
  </div>
</button>
